import { QrTemplate, QrTemplateColors, EditableSlot } from './types';

const SANS = '-apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif';
const SERIF = 'Georgia, "Times New Roman", serif';

const slots: EditableSlot[] = [
  {
    id: 'eyebrow',
    label: 'Oberes Label',
    defaultValue: 'TERMIN  •  WHATSAPP',
    modeVariants: { whatsapp: 'TERMIN  •  WHATSAPP', vcard: 'KONTAKT  •  SPEICHERN' },
    positionable: true,
  },
  {
    id: 'cta',
    label: 'Call-to-Action',
    defaultValue: 'Scannen & buchen',
    modeVariants: { whatsapp: 'Scannen & buchen', vcard: 'Scannen & speichern' },
    positionable: true,
  },
];

export const windowSticker: QrTemplate = {
  id: 'window-sticker',
  name: 'Schaufenster-Aufkleber',
  description: 'Runder Aufkleber für Salontür oder Schaufenster – minimal, elegant, sofort scannbar.',
  format: 'Ø 1200 px (rund ausschneidbar)',
  canvasWidth: 1200,
  canvasHeight: 1200,
  slots,

  defaultColors: {
    background: '#1C1A18',
    surface:    '#FAF7F2',
    text:       '#FAF7F2',
    textMuted:  '#A89F93',
    accent:     '#C9A96E',
    onAccent:   '#1C1A18',
  } satisfies QrTemplateColors,

  render: ({ ctx, canvas, qrImage, business, colors, slotValues, slotOffsets }) => {
    const W = canvas.width;
    const H = canvas.height;
    const CX = W / 2;
    const CY = H / 2;
    const { background, text, textMuted, accent } = colors;
    const WHITE = '#FFFFFF';

    ctx.clearRect(0, 0, W, H);

    ctx.save();
    ctx.beginPath();
    ctx.arc(CX, CY, W / 2 - 6, 0, Math.PI * 2);
    ctx.fillStyle = background;
    ctx.fill();
    ctx.restore();

    ctx.save();
    ctx.beginPath();
    ctx.arc(CX, CY, W / 2 - 48, 0, Math.PI * 2);
    ctx.strokeStyle = accent;
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.restore();

    const eyeOff = slotOffsets.eyebrow;
    const labelY = 190 + eyeOff.y;
    ctx.save();
    ctx.font = `500 22px ${SANS}`;
    (ctx as any).letterSpacing = '10px';
    ctx.fillStyle = accent;
    ctx.textAlign = 'center';
    ctx.fillText(slotValues.eyebrow, CX + 5 + eyeOff.x, labelY);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();

    ctx.save();
    ctx.fillStyle = accent;
    ctx.beginPath();
    ctx.arc(CX, labelY + 28, 3, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    const QR_SIZE = 560;
    const QR_PAD = 34;
    const QR_TOTAL = QR_SIZE + QR_PAD * 2;
    const qrX = CX - QR_TOTAL / 2;
    const qrY = CY - QR_TOTAL / 2 - 30;

    ctx.save();
    ctx.fillStyle = WHITE;
    ctx.fillRect(qrX, qrY, QR_TOTAL, QR_TOTAL);
    ctx.restore();

    ctx.drawImage(qrImage, qrX + QR_PAD, qrY + QR_PAD, QR_SIZE, QR_SIZE);

    const ctaOff = slotOffsets.cta;
    const ctaY = qrY + QR_TOTAL + 82 + ctaOff.y;
    ctx.save();
    ctx.font = `700 42px ${SERIF}`;
    ctx.fillStyle = text;
    ctx.textAlign = 'center';
    ctx.fillText(slotValues.cta, CX + ctaOff.x, ctaY);
    ctx.restore();

    const nameY = ctaY + 56;
    let nameSize = 28;
    const nameMaxW = W - 320;
    ctx.font = `400 ${nameSize}px ${SANS}`;
    while (ctx.measureText(business.name).width > nameMaxW && nameSize > 16) {
      nameSize -= 1;
      ctx.font = `400 ${nameSize}px ${SANS}`;
    }
    ctx.save();
    ctx.fillStyle = textMuted;
    ctx.textAlign = 'center';
    ctx.fillText(business.name, CX, nameY);
    ctx.restore();

    const phone = business.whatsappNumber.startsWith('+')
      ? business.whatsappNumber
      : '+' + business.whatsappNumber.replace(/\D/g, '');
    const phoneY = nameY + 36;
    ctx.save();
    ctx.font = `400 22px ${SANS}`;
    (ctx as any).letterSpacing = '2px';
    ctx.fillStyle = accent;
    ctx.textAlign = 'center';
    ctx.fillText(phone, CX + 1, phoneY);
    (ctx as any).letterSpacing = '0px';
    ctx.restore();
  },
};
